import { Component, PLATFORM_ID, Inject, OnInit } from '@angular/core';
import { LoadingBarService } from '@ngx-loading-bar/core';
import { map, delay, withLatestFrom } from 'rxjs/operators';
import { AuthService } from './shared/services/auth.service'; // 👈 importa tu servicio

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  // For Progressbar
  loaders: any;

  constructor(
    @Inject(PLATFORM_ID) private platformId: Object,
    private loader: LoadingBarService,
    private auth: AuthService // 👈 inyecta el servicio de auth
  ) {
    this.loaders = this.loader.progress$.pipe(
      delay(1000),
      withLatestFrom(this.loader.progress$),
      map(v => v[1]),
    );
  }

  ngOnInit() {
    // No cargar perfil en rutas públicas (evita 401 innecesario cuando no hay sesión)
  const isPublicRoute =
    window.location.pathname.includes('/encuestas/responder/') ||
    window.location.pathname.includes('/Invitacion') || 
    window.location.pathname.includes('/Asistencia')
    ;
    if (!isPublicRoute) {
      this.auth.getProfile().subscribe({
        next: (user) => this.auth['currentUserSubject'].next(user),
        error: () => this.auth.clearLocalState()
      });
    }else{
     // console.log("PUBLICO");
    }
  }
}
